export const CacheTypes = {
  IMC: "IN_MEM_CACHE",
  FBC: "FILE_BASED_CACHE",
  DEFAULT: "IN_MEM_CACHE",
};
